import './styles.scss'

import { useTranslation } from 'react-i18next'
import { Col, Row } from 'antd'
import clsx from 'clsx'

import B2becShopCategoryBlock from '@/components/B2becShopCategoryBlock'
import { useAppSelector } from '@/store/hook'
import { selectIsFuturetech } from '@/store/selectors/configSelector'
import { SHOP_CATEGORY_TYPE } from '@/libs/constants'

const ShopByCategories = () => {
  const { t } = useTranslation()
  const isFuturetech = useAppSelector(selectIsFuturetech)
  const className = isFuturetech ? 'futuretech' : 'karcher'

  return (
    <div className={clsx('shop-categories', className)}>
      <h2 className="shop-categories__title">{t('shopByCategory.title')}</h2>
      <Row gutter={[24, 24]}>
        <Col lg={8} span={24}>
          <B2becShopCategoryBlock
            type={SHOP_CATEGORY_TYPE.MACHINES}
            context={isFuturetech ? 'futuretech' : 'karcher'}
            priority={true}
          />
        </Col>
        <Col lg={8} span={24}>
          <B2becShopCategoryBlock
            type={SHOP_CATEGORY_TYPE.ACCESSORIES}
            context={isFuturetech ? 'futuretech' : 'karcher'}
            priority={true}
          />
        </Col>
        <Col lg={8} span={24}>
          <B2becShopCategoryBlock
            type={SHOP_CATEGORY_TYPE.DETERGENTS}
            context={isFuturetech ? 'futuretech' : 'karcher'}
            priority={true}
          />
        </Col>
      </Row>
    </div>
  )
}

export default ShopByCategories
